import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { OAuthService } from 'angular-oauth2-oidc';
import {
  BehaviorSubject,
  Observable,
  Subject,
  from,
  of,
  throwError,
} from 'rxjs';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';
import {
  authCodeFlowConfig,
  customOauth2Config,
  getDeviceId,
} from 'src/assets/config/oauth2-config';
import { StyleManagerService } from './theme-manager.service';
import { Response } from '../models/response.model';
import { EncryptionService } from './encryption.service';
import { Language } from '../models/language-details.model';
import { Preferences } from '../models/user-preference.model';
// import { AppConfig } from '../models/appconfig.model';
import { AuthType, CaptchaType } from '../constants/digigov.constants';

export interface AppConfig {
  P2_DATA_ENC_ENABLE: boolean;
  baseUrl: string;
  baseGlobalMater: string;
  basePayeeUrl: string;
  baseDepositUrl: string;
  baseCommonUrl: string;
  websocketUrl: string;
  dgDocUrl: string;
  docUrl: string;
  matUrl: string;
  websocket: boolean;
 privSubType: number;
  privSubTypeVal: number;
  setCountDownTime: number;
  showSessionChecker: boolean;
  showSessionCheckerAt: number
  dataPrivacy: boolean;
  dev: boolean;
  showDevNodes: boolean;
  showTestNodes: boolean;
  toggleSideBar: boolean;
  showEnvDetails: boolean;
  privGuard: boolean;
  authType: string;
  authenticationLogoutUrl: string;
  afterLoginLandingUrl: string;
  unauthorizedUrl: string;
  payload:string;
  preAuthLogoutUrl:string;
  hasRoleBasedRouting:string;
  demoPayment:string;
  showPwdExpireMsgBanner:string;
  onlyofficeDocumentServerUrl:string;
  disableDevTools:string;
  searchPostWithEmp:string;
  communiqueUrl:string;
  moduleWiseBuild:
  {
    buildReport: []
  }
 

  oauth2Config: {
    issuer: string;
    clientId: string;
    scope: string;
    addDeviceId: boolean;
    refreshTokenEnabled: boolean;
    refreshTokenType: string;
    requireHttps: boolean;
  };
  showLogOutConfirmation: boolean;
  encryptPassword: boolean;
  environment: string;
  showForgotPassword: boolean;
  captchaType: CaptchaType;
  recaptchaV3SiteKey: string;
  defaultTheme: string;
  editableOnboardingScreen: boolean;
  encryptFileUploadInput: boolean;
  branding: {
    mainLogo: string;
    footerLogo: string;
    copyright: string;
  };

  breakPoints: {
    xs: number;
    sm: number;
    min_sm: number;
    md: number;
    min_md: number;
    lg: number;
    min_lg: number;
    xl: number;
    min_xl: number;
    xxl: number;
    min_xxl: number;
  };
  configurableFields: any;
  defaultFormats: any;
  ckeditorConfig: {
    extraFonts: string;
    font_css: [string];
    [key: string]: any;
  };
}

export interface Locale {
  id: number;
  label: string;
  value: string;
}

export interface UserPreferenceData {
  fullTimeFormat?: string;
  dateFormat?: string;
  mediumDateTimeFormat?: string;
  medium?: string;
  shortDateTimeFormat?: string;
  long?: string;
  local?: string;
  fullDate?: string;
  dateTimeFormat?: string;
  mediumTime?: string;
  longDate?: string;
  currency?: string;
  theme?: string;
  longDateTimeFormat?: string;
  shortTimeFormat?: string;
  shortDate?: string;
  longTimeFormat?: string;
  shortDateFormat?: string;
  fullTime?: string;
  mediumDateFormat?: string;
  fullDateTimeFormat?: string;
  dashboardLayoutId?: string;
  longDateFormat?: string;
  longTime?: string;
  mediumDate?: string;
  PMOC?: string;
  fullDateFormat?: string;
  shortTime?: string;
  timeFormat?: string;
  short?: string;
  mediumTimeFormat?: string;
  caseViewLayoutId?: string;
  langId?: string;
  full?: string;
}


@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  private _appConfig: AppConfig = null;
  _lang = 'en';
  _langList: Language[] = [];

  _thm = 'default';
  _theme;
  _themeList = [];
 

  private _sidebarInstance: MatDrawer;
  dashboardLayoutId = '1';
  caseViewLayoutId = '4';
  userPreferenceData: Preferences = null;
  private _locale: any;
  private _locales: any[];
  localesList = [];
  private data: any[] = [
    {
      locale: 'en_US',
    },
    {
      locale: 'en_IN',
    },
    {
      locale: 'hi_IN',
    },
    {
      locale: 'en_AU',
    },
    {
      locale: 'en_GB',
    },
  ];
  languageSubject: Subject<string>;
  public appLocaleSubject: BehaviorSubject<any>;
  selectedLang: any;
  projectId;
  loginLogoId;
  headerLogoId;
  shortDateList = [];
  longDateList = [];
  dateFormatList = [];
  timeFormatList = [];
  shortTimeList = [];
  longTimeList = [];
  medDateList = [];
  fullDateList = [];
  medTimeList = [];
  fullTimeList = [];
  dtFormatList = [];
  shortDtList = [];
  longDtList = [];
  medDtList = [];
  fullDtList = [];
  //OIDC
  public isDoneLoadingSubject$ = new BehaviorSubject<boolean>(true);
  public isDoneLoading$ = this.isDoneLoadingSubject$.asObservable();
  private receivedOauthTokenSubject$ = new BehaviorSubject<boolean>(false);
  public receivedOauthToken$ = this.receivedOauthTokenSubject$.asObservable();
  public isAfterLoginDone = true;
  hasOauth2TokenExpired = false;
  oauth2TokenCall = false;
  oauth2AccessTokenReceived: Subject<string> = new Subject();

  //appConfig Obs
  private appConfigSub = new BehaviorSubject<AppConfig>(this._appConfig);
  public appConfigObs = this.appConfigSub.asObservable();

  //SessionId Url
  sessionCheckerIdUrl = '/security/session-checker';
  constructor(
    private http: HttpClient,
    private readonly styleManager: StyleManagerService,
    //OIDC
    private oauthService: OAuthService,
    private encryptService: EncryptionService
  ) {
    this.languageSubject = new Subject();
    this.appLocaleSubject = new BehaviorSubject<any>(this._locale);
  }

  get sidebarInstance(): MatDrawer {
    return this._sidebarInstance;
  }

  set sidebarInstance(si: MatDrawer) {
    this._sidebarInstance = si;
  }

  toggleSidebar = () => this._sidebarInstance?.toggle();

  closeSidebar = () => this._sidebarInstance?.close();

  get theme(): string {
    return this._thm;
  }
  get language(): string {
    return this._lang;
  }
  set language(lang: string) {
    this._lang = lang;
    this.languageSubject.next(this._lang);
  }
  get langId(): number | string {
    return '1';
  }

  get appConfig(): AppConfig {
    return this._appConfig;
  }

  get locale(): any {
    return this._locale;
  }

  set locale(locale: any) {
    if (this.locales.find((l) => l.locale === locale.locale)) {
      this._locale = locale;
    } else {
      throw new Error('locale not found');
    }
  }

  get locales(): any[] {
    return this._locales;
  }

  getLocales(path: string): Observable<Language> {
    return this.http.get(path).pipe(
      tap((data: any) => {
        if (data) {
          this._locales = data;
        }
      })
    );
  }
  imagesource = './assets/images/login-page-logo.png';
  getLogoId(): void {
    this.projectId = 8;
    if (this.projectId) {
      let params = new HttpParams();
      params = params.append('projectId', this.projectId);
      this.http
        .get('/admin/project-config-details', { params: params })
        .subscribe((res) => {
          const restemp: any = res;
          if (restemp?.data?.docFileType) {
            this.imagesource =
              'data:image/' +
              restemp?.data?.docFileType +
              ';base64,' +
              restemp?.data?.fileBytes;
          }
          this.loginLogoId = restemp?.data?.loginAttachId;
          this.headerLogoId = restemp?.data?.headerAttachId;
          localStorage.setItem('headerLogoId', this.headerLogoId);
          localStorage.setItem('loginLogoId', this.loginLogoId);
        });
    }
  }
  determineCaptchaType(): void {
    if (
      Object.values<string>(CaptchaType).includes(
        this._appConfig?.captchaType?.toString()?.toLowerCase()
      )
    ) {
      this._appConfig.captchaType = this._appConfig?.captchaType
        ?.toString()
        ?.toLowerCase() as CaptchaType;
    } else {
      this._appConfig.captchaType = CaptchaType.TEXT;
    }
  }

  initAppConfig = (path: string): Observable<AppConfig> =>
    this.http.get<AppConfig>(path).pipe(
      tap((appConfig) => {
        if (appConfig) {
          this._appConfig = appConfig;
          this.appConfigSub.next(this._appConfig);
          if(this._appConfig?.encryptFileUploadInput){
          localStorage.setItem(
            'encryptFileUploadInput',
            JSON.stringify({
              encryptFileUploadInput: this._appConfig?.encryptFileUploadInput,
            })
          );
        }
          this.getLogoId();
          this.determineCaptchaType();
        }
      })
    );

  getUserPreference = (): Observable<any> => {
    if (
      localStorage.getItem('userAuthToken') ||
      (this.oauthService.hasValidAccessToken() &&
        !(
          (new Date() >
            new Date(this.oauthService.getAccessTokenExpiration()) ||
            new Date() ==
              new Date(this.oauthService.getAccessTokenExpiration())) &&
          !!this.oauthService.getRefreshToken()
        )) ||
      this.appConfig.authType === AuthType.PRE_AUTH
    ) {
      return this.populateLang().pipe(
        switchMap(() => {
          return this.http.get('/core/user-preferences').pipe(
            switchMap((res: any) => {
              const resData: any = res.data;
              this.userPreferenceData = resData?.preferences;
              localStorage.setItem(
                'userPreferenceData',
                JSON.stringify(this.userPreferenceData)
              );
              this.dashboardLayoutId = resData.preferences?.dashboardLayoutId
                ? resData.preferences?.dashboardLayoutId
                : this.dashboardLayoutId;
              this.caseViewLayoutId = resData.preferences?.caseViewLayoutId
                ? resData.preferences?.caseViewLayoutId
                : this.caseViewLayoutId;
              localStorage.setItem(
                'layoutId',
                JSON.stringify({
                  dashboardLayoutId: this.dashboardLayoutId,
                  caseViewLayoutId: this.caseViewLayoutId,
                })
              );
              this.locale.locale = resData.preferences?.local
                ? resData.preferences?.local
                : this.locale.locale;
              this.locale.currency = resData.preferences?.currency
                ? resData.preferences?.currency
                : this.locale.currency;
              return this.registerCulture(this.locale).pipe(
                tap(() => {
                  this.locale.dateFormat = resData.preferences?.dateFormat
                    ? resData.preferences?.dateFormat
                    : this.locale.dateFormat;
                  this.locale.shortDateFormat = resData.preferences
                    ?.shortDateFormat
                    ? resData.preferences?.shortDateFormat
                    : this.locale.shortDateFormat;
                  this.locale.mediumDateFormat = resData.preferences
                    ?.mediumDateFormat
                    ? resData.preferences?.mediumDateFormat
                    : this.locale.mediumDateFormat;
                  this.locale.longDateFormat = resData.preferences
                    ?.longDateFormat
                    ? resData.preferences?.longDateFormat
                    : this.locale.longDateFormat;
                  this.locale.fullDateFormat = resData.preferences
                    ?.fullDateFormat
                    ? resData.preferences?.fullDateFormat
                    : this.locale.fullDateFormat;
                  this.locale.timeFormat = resData.preferences?.timeFormat
                    ? resData.preferences?.timeFormat
                    : this.locale.timeFormat;
                  this.locale.shortTimeFormat = resData.preferences
                    ?.shortTimeFormat
                    ? resData.preferences?.shortTimeFormat
                    : this.locale.shortTimeFormat;
                  this.locale.longTimeFormat = resData.preferences
                    ?.longTimeFormat
                    ? resData.preferences?.longTimeFormat
                    : this.locale.longTimeFormat;
                  this.locale.mediumTimeFormat = resData.preferences
                    ?.mediumTimeFormat
                    ? resData.preferences?.mediumTimeFormat
                    : this.locale.mediumTimeFormat;
                  this.locale.fullTimeFormat = resData.preferences
                    ?.fullTimeFormat
                    ? resData.preferences?.fullTimeFormat
                    : this.locale.fullTimeFormat;
                  this.locale.dateTimeFormat = resData.preferences
                    ?.dateTimeFormat
                    ? resData.preferences?.dateTimeFormat
                    : this.locale.dateTimeFormat;
                  this.locale.shortDateTimeFormat = resData.preferences
                    ?.shortDateTimeFormat
                    ? resData.preferences?.shortDateTimeFormat
                    : this.locale.shortDateTimeFormat;
                  this.locale.longDateTimeFormat = resData.preferences
                    ?.longDateTimeFormat
                    ? resData.preferences?.longDateTimeFormat
                    : this.locale.longDateTimeFormat;
                  this.locale.mediumDateTimeFormat = resData.preferences
                    ?.mediumDateTimeFormat
                    ? resData.preferences?.mediumDateTimeFormat
                    : this.locale.mediumDateTimeFormat;
                  this.locale.fullDateTimeFormat = resData.preferences
                    ?.fullDateTimeFormat
                    ? resData.preferences?.fullDateTimeFormat
                    : this.locale.fullDateTimeFormat;
                  this._themeList.forEach((element) => {
                    if (resData.preferences?.theme === element.id.toString()) {
                      this.locale.theme = resData.preferences?.theme;
                      this.currentTheme = element;
                      localStorage.setItem(
                        'selected-theme',
                        JSON.stringify(element)
                      );
                    }
                  });
                  const langCode = Number(
                    resData.preferences?.langId
                      ? resData.preferences?.langId
                      : 1
                  );
                  this._langList.forEach((lang) => {
                    if (langCode === lang?.langId) {
                      this.selectedLang = lang;
                      this.language = lang?.langCode
                        ? lang?.langCode
                        : this.language;
                    }
                  });
                  localStorage.setItem('appLanguage', this.language);
                })
              );
            })
          );
        })
      );
    } else {
      return of(false);
    }
  };

  getConfigurableFields(): Observable<AppConfig> {
    return this.http
      .get('/core/constant/configurableFields?propertyFile=configurableFields')
      .pipe(
        tap((res: any) => {
          const resData = res?.data?.configurableFields;
          Object.keys(resData)?.forEach((ele) => {
            if (resData[ele]?.toString()?.trim()?.toLowerCase() === 'true') {
              resData[ele] = true;
            } else if (
              resData[ele]?.toString()?.trim()?.toLowerCase() === 'false'
            ) {
              resData[ele] = false;
            }
          });
          let appConfigurableFields = this._appConfig?.configurableFields;

          appConfigurableFields = { ...appConfigurableFields, ...resData };
          this.appConfig.configurableFields = { ...appConfigurableFields };
        })
      );
  }
  fetchThemes(path: string): Observable<any> {
    return this.http.get(path).pipe(
      tap((data: any) => {
        if (data) this._themeList = data;
        try {
          this.currentTheme = JSON.parse(
            localStorage.getItem('selected-theme')
          );
        } catch (error) {
          if (this.appConfig?.defaultTheme) {
            document
              .querySelector('body')
              .classList.add(this.appConfig?.defaultTheme);
            this._theme = this._themeList[
              this._themeList.findIndex(
                (t) => t?.value === this.appConfig?.defaultTheme
              )
            ];
          } else {
            this._theme = this._themeList[0];
            document.querySelector('body').classList.add(this._theme?.value);
          }
        }
      })
    );
  }

  get currentTheme() {
    return this._theme;
  }

  set currentTheme(theme) {
    this._theme = theme;
    this.styleManager.setStyle(this.currentTheme.value);
  }
  switchLocaleLazyLoad = (locale: string, lang?: any): void => {
    localStorage.setItem('appLocale', JSON.stringify(locale));
    localStorage.setItem('appLanguage', lang?.langCode);
    this.selectedLang = lang;
    this.language = lang?.langCode;
    this.appLocaleSubject.next(locale);
    this._locale = locale;

    window.location.href = this._appConfig.afterLoginLandingUrl;
    this.registerCulture(locale).subscribe();
  };

  switchLanguage = (lang: any): void => {
    localStorage.setItem('appLanguage', lang?.langCode);
    this.selectedLang = lang;
    this.language = lang?.langCode;
    window.location.reload();
  };

  registerCulture = (locale: any): Observable<any> => {
    if (!locale) {
      this._locales = this.data;
      this.locale = this.appConfig.defaultFormats;
      locale = this.locale;
      if (!localStorage.getItem('appLocale')) {
        localStorage.setItem('appLocale', JSON.stringify(this.locale));
      }
    }
    let lang: { default: any };
    let localeId: string = locale?.locale?.replace('_', '-');
    return from(
      import(
        /* webpackInclude: /(en|en-IN|hi)\.mjs$/ */
        `/node_modules/@angular/common/locales/${localeId}.mjs`
      )
    ).pipe(
      tap((data: { default: any }) => {
        lang = data;
        registerLocaleData(lang.default);
        this.locale = locale;
      }),
      catchError((e) => {
        if (localeId.indexOf('-') < 0) {
          return throwError(e);
        }
        localeId = localeId.substring(0, localeId.indexOf('-'));
        return from(
          import(
            /* webpackInclude: /(en|hi)\.mjs$/ */
            `/node_modules/@angular/common/locales/${localeId}.mjs`
          )
        ).pipe(
          tap((data: { default: any }) => {
            lang = data;
            registerLocaleData(lang.default);
            this.locale = locale;
          }),
          catchError((e) => throwError(e))
        );
      })
    );
  };
  populateLang(): Observable<Language[]> {
    return this.http.get<Response<Language[]>>('/admin/language-details').pipe(
      map((res) => res.data),
      tap((langList) => {
        this._langList = langList;
        langList.forEach((loc) => {
          loc['displayName'] = loc?.langName + ' (' + loc.countryCode + ')';
        });
        this.localesList = langList;
        this._locales = langList;
      })
    );
  }

  getMicroserviceDtls(): void {
    this.http
      .get('/admin/application/microservicecode-appcode-mpg')
      .subscribe((data) => {
        const microServiceContextData = JSON.parse(data['data']);
        localStorage.setItem(
          'micro_services',
          JSON.stringify(microServiceContextData)
        );
      });
    this.http
      .get('/admin/microservice/code-contextpath-mpg')
      .subscribe((data) => {
        const microServiceContextData = JSON.parse(data['data']);
        localStorage.setItem(
          'contextPath',
          JSON.stringify(microServiceContextData)
        );
      });
  }

  //OIDC
  public runInitialLoginSequence(): Observable<void> {
    this.isDoneLoadingSubject$.next(false);
    window.addEventListener('storage', (event) => {
      if (event.key !== 'access_token' && event.key !== null) {
        return;
      }
      if (!this.oauthService.hasValidAccessToken()) {
        this.logOutWithOIDC();
      }
    });
    this.oauthService.events
      .pipe(filter((e) => ['token_received'].includes(e.type)))
      .subscribe(() => {
        this.hasOauth2TokenExpired = false;
        this.isAfterLoginDone = false;
        this.receivedOauthTokenSubject$.next(true);
      });
    this.oauthService.events
      .pipe(filter((e) => ['token_expires'].includes(e.type)))
      .subscribe(() => {
        this.hasOauth2TokenExpired = true;
      });
    this.oauthService.events
      .pipe(
        filter((e) =>
          [
            'session_terminated',
            'session_error',
            'token_refresh_error',
          ].includes(e.type)
        )
      )
      .subscribe(() => {
        this.logOutWithOIDC();
      });
    authCodeFlowConfig.issuer = this._appConfig.oauth2Config.issuer;
    authCodeFlowConfig.clientId = this._appConfig.oauth2Config.clientId;
    authCodeFlowConfig.scope = this._appConfig.oauth2Config.scope;
    authCodeFlowConfig.requireHttps = this._appConfig.oauth2Config.requireHttps;
    if (this._appConfig.oauth2Config.addDeviceId) {
      authCodeFlowConfig.scope =
        authCodeFlowConfig.scope?.trim() + ' device_' + getDeviceId();
    }
    this.oauthService.configure(authCodeFlowConfig);
    customOauth2Config.refreshTokenEnabled = this._appConfig.oauth2Config.refreshTokenEnabled;
    customOauth2Config.refreshTokenType = this._appConfig.oauth2Config.refreshTokenType;
    if (
      customOauth2Config.refreshTokenEnabled &&
      customOauth2Config?.refreshTokenType.toLocaleLowerCase() === 'auto'
    ) {
      this.oauthService.setupAutomaticSilentRefresh();
    }
    return from(
      this.oauthService
        .loadDiscoveryDocument()
        .then(() => this.oauthService.tryLogin())
        .then(() => {
          if (this.oauthService.hasValidAccessToken()) {
            return Promise.resolve();
          }
        })
        .then(() => {
          if (this.isAfterLoginDone) {
            this.isDoneLoadingSubject$.next(true);
          }
        })
        .catch((e) => this.isDoneLoadingSubject$.next(true))
    );
  }
  loginWithOIDC(additionalState?: string): void {
    this.isDoneLoadingSubject$.next(false);
    this.oauthService.initCodeFlow(additionalState);
  }
  logOutWithOIDC(): void {
    this.isDoneLoadingSubject$.next(false);
    this.oauthService.logOut();
  }

  disableConsoleInProduction(): void {
    Object.keys(window.console)?.forEach((ele) => {
      if (ele !== 'error' && ele !== 'warn') {
        window.console[ele] = function (): void {};
      }
    });
  }
  getSessionCheckerId(): Observable<string> {
    const sessionObs = new Subject<string>();
    this.http
      .post<Response<{ sessionCheckerId: string }>>(
        this.sessionCheckerIdUrl,
        {}
      )
      .pipe(map((res) => res.data.sessionCheckerId))
      .subscribe((id) => {
        sessionObs.next(id);
      });
    return sessionObs.pipe(take(1));
  }
  generateSessionClientId(id: number, maxLength = 4): string {
    let result = '';
    let characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < maxLength; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return id === 1 || id === 4
      ? result
      : id === 2
      ? this.encryptService.generateSalt()
      : '';
  }
  clientId(min = 1, max = 4): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
}
